import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { PassesForSaleFailReason } from "ipctg-inflow-types/InFlowEnums";

import type { ParkPassesForSalePOSTErrorResponse, ParkPassesForSalePOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchPassesForSale = async (): Promise<ParkPassesForSalePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPassesForSalePOSTSuccessResponse>("/passes-for-sale");
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPassesForSalePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PassesForSaleFailReason };
  }
};
